import { render, staticRenderFns } from "./dynamicDetail.vue?vue&type=template&id=152a432b"
import script from "./dynamicDetail.vue?vue&type=script&lang=js"
export * from "./dynamicDetail.vue?vue&type=script&lang=js"
import style0 from "./dynamicDetail.vue?vue&type=style&index=0&id=152a432b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports